import { Component } from '@ecs/Component';

export class Energy implements Component {
  readonly type = 'Energy';

  constructor(
    public current: number,
    public max: number,
    public regenRate: number = 0.5
  ) {}
}